import { render, staticRenderFns } from "./TeachersKyBot.vue?vue&type=template&id=9cf8a4a6&scoped=true&"
import script from "./TeachersKyBot.vue?vue&type=script&lang=js&"
export * from "./TeachersKyBot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf8a4a6",
  null
  
)

export default component.exports